import React from 'react';
import Heading from '@atlaskit/heading';
import MobileIcon from '@atlaskit/icon/glyph/mobile';
import NotificationDirectIcon from '@atlaskit/icon/glyph/notification-direct';
import SettingsIcon from '@atlaskit/icon/glyph/settings';
import { Flex, Text } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { IconBoxColor, IconBox } from '../../../../common/ui/icon-box';
import { messages } from './messages';

export const StepOne = () => {
	const { formatMessage } = useIntl();

	const sections = [
		{
			icon: { component: NotificationDirectIcon, color: IconBoxColor.Orange },
			title: formatMessage(messages.alertsTitle),
			description: formatMessage(messages.alertsDescription),
		},
		{
			icon: { component: SettingsIcon, color: IconBoxColor.Lime },
			title: formatMessage(messages.operationsTitle),
			description: formatMessage(messages.operationsDescription),
		},
		{
			icon: { component: MobileIcon, color: IconBoxColor.Teal },
			title: formatMessage(messages.mobileTitle),
			description: formatMessage(messages.mobileDescription),
		},
	];

	return (
		<Flex direction="column" rowGap="space.300">
			<Flex rowGap="space.100" direction="column">
				<Heading size="xlarge">{formatMessage(messages.title)}</Heading>
				<Text>{formatMessage(messages.description)}</Text>
			</Flex>
			{sections.map((section, i) => (
				<Flex key={i} direction="column" rowGap="space.100">
					<Flex columnGap="space.075" alignItems="center">
						<IconBox icon={section.icon.component} color={section.icon.color} />
						<Heading as="h2" size="xsmall">
							{section.title}
						</Heading>
					</Flex>
					<Text>{section.description}</Text>
				</Flex>
			))}
		</Flex>
	);
};
